export const formatFullName = (firstName: Maybe<string>, lastName: Maybe<string>): string => [firstName, lastName].filter(Boolean).join(' ').trim();
